import React from 'react';
import './loading-rocket.css';
import conf from '../../conf';
const LoadingRocket = () => (React.createElement("div", { className: 'container' },
    React.createElement("img", { alt: 'loading rocket', className: 'rocket animated', src: `${conf.ASSET_PATH}/assets/images/rocket/ship-ignited.svg` }),
    React.createElement("img", { alt: 'stars', className: 'stars', src: `${conf.ASSET_PATH}/assets/images/rocket/stars.svg` }),
    React.createElement("div", { className: 'land-container' },
        React.createElement("img", { alt: 'land', src: `${conf.ASSET_PATH}/assets/images/rocket/land.png` }),
        React.createElement("img", { alt: 'land', className: 'land2', src: `${conf.ASSET_PATH}/assets/images/rocket/land.png` }))));
export default LoadingRocket;
